// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__hnMBW","icon":"styles_icon__HPZlY","scrollbars":"styles_scrollbars__cUYPd","slideInSearchBar":"styles_slideInSearchBar__gfdJ9"};